(function () {
  'use strict';
  if (window.URAMobileFitDemo) return;

  var instances = new Map();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var selector = '[data-ura-mobile-fit-demo]';

  function parse(node) {
    try { return JSON.parse(node.textContent); } catch (error) { return {}; }
  }

  function setup(root) {
    if (instances.has(root)) return instances.get(root);
    var data = parse(root.querySelector('[data-mfit-data]'));
    var copy = data.copy || {};
    var inputUnit = String(data.unit || '').toLowerCase();
    var factor = ['in', 'inch', 'inches'].includes(inputUnit) ? 2.54 : inputUnit === 'cm' ? 1 : 0;
    var width = Number(data.width) * factor;
    var length = Number(data.length) * factor;
    var valid = data.verified === true && width > 0 && length > 0 && Number.isFinite(width) && Number.isFinite(length);
    var targets = { width: width, length: length };
    var heading = root.querySelector('[data-mfit-heading]');
    var hint = root.querySelector('[data-mfit-hint]');
    var reading = root.querySelector('[data-mfit-reading]');
    var ticks = root.querySelector('[data-mfit-ticks]');
    var replay = root.querySelector('[data-mfit-replay]');
    var status = root.querySelector('[data-mfit-status]');
    var controls = Array.from(root.querySelectorAll('[data-mfit-select]'));
    var units = Array.from(root.querySelectorAll('[data-mfit-unit]'));
    var lines = Array.from(root.querySelectorAll('[data-mfit-line]'));
    var active = false;
    var playing = false;
    var axis = 'width';
    var unit = 'in';
    var frame = 0;
    var start = null;
    var numberFormat;
    try { numberFormat = new Intl.NumberFormat(data.locale || 'en', { minimumFractionDigits: 1, maximumFractionDigits: 1 }); } catch (error) { numberFormat = new Intl.NumberFormat('en', { minimumFractionDigits: 1, maximumFractionDigits: 1 }); }

    function motion(progress) {
      root.style.setProperty('--mfit-progress', String(progress));
      root.style.setProperty('--mfit-offset', ((1 - progress) * 20) + '%');
    }

    function stop() {
      window.cancelAnimationFrame(frame);
      frame = 0;
      playing = false;
      root.dataset.mfitPlaying = 'false';
      replay.textContent = copy.replay || '';
      motion(1);
    }

    function canPlay() {
      var dialog = root.closest('dialog');
      return active && valid && root.isConnected && !document.hidden && !reduced.matches && !root.closest('[hidden]') && (!dialog || dialog.open);
    }

    function drawTape() {
      if (!valid) return;
      var scale = unit === 'in' ? 2.54 : 1;
      var minimum = (targets[axis] - 6.35) / scale;
      var maximum = (targets[axis] + 6.35) / scale;
      var increment = unit === 'in' ? .125 : .5;
      var every = unit === 'in' ? 8 : 10;
      var extension = (maximum - minimum) / 2;
      var first = Math.ceil(Math.max(0, minimum - extension) / increment);
      var last = Math.floor((maximum + extension) / increment);
      var count = Math.max(0, Math.min(200, last - first + 1));
      var fragment = document.createDocumentFragment();
      for (var offset = 0; offset < count; offset++) {
        var index = first + offset;
        var value = index * increment;
        var tick = document.createElement('span');
        var major = index % every === 0;
        tick.className = 'ura-mfit-demo__tick' + (major ? ' is-major' : index % 2 === 0 ? ' is-mid' : '');
        tick.style.left = ((value - minimum) / (maximum - minimum) * 100) + '%';
        if (major) {
          var label = document.createElement('b');
          label.textContent = String(Math.round(value));
          tick.appendChild(label);
        }
        fragment.appendChild(tick);
      }
      ticks.replaceChildren(fragment);
      reading.textContent = numberFormat.format(targets[axis] / scale) + ' ' + (copy[unit] || unit);
    }

    function show(next, announce) {
      axis = next;
      root.dataset.mfitAxis = next;
      heading.textContent = copy[next] || heading.textContent;
      hint.textContent = copy[next + '_hint'] || hint.textContent;
      controls.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.mfitSelect === next)); });
      lines.forEach(function (line) {
        if (line.dataset.mfitLine === next) line.removeAttribute('hidden');
        else line.setAttribute('hidden', '');
      });
      drawTape();
      motion(1);
      if (announce) status.textContent = [heading.textContent, hint.textContent, valid ? reading.textContent : ''].filter(Boolean).join('. ');
    }

    function tick(now) {
      frame = 0;
      if (!canPlay()) { stop(); return; }
      if (start === null) start = now;
      var elapsed = now - start;
      var next = elapsed < 2400 ? 'width' : 'length';
      if (axis !== next) show(next, false);
      var local = elapsed - (next === 'width' ? 0 : 2400);
      var progress = Math.max(0, Math.min(1, (local - 200) / 1700));
      motion(progress * progress * (3 - 2 * progress));
      if (elapsed >= 4800) { stop(); return; }
      frame = window.requestAnimationFrame(tick);
    }

    function play() {
      stop();
      show('width', false);
      if (!canPlay()) return;
      playing = true;
      start = null;
      root.dataset.mfitPlaying = 'true';
      replay.textContent = copy.pause || '';
      motion(0);
      frame = window.requestAnimationFrame(tick);
    }

    function onClick(event) {
      var button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.hasAttribute('data-mfit-select')) {
        stop();
        show(button.dataset.mfitSelect, true);
      } else if (button.hasAttribute('data-mfit-unit')) {
        stop();
        unit = button.dataset.mfitUnit;
        units.forEach(function (item) { item.setAttribute('aria-pressed', String(item.dataset.mfitUnit === unit)); });
        show(axis, true);
      } else if (button === replay) {
        if (playing) stop();
        else play();
      }
    }

    function setActive(value) {
      var changed = active !== Boolean(value);
      active = Boolean(value);
      root.dataset.mfitActive = String(active);
      if (!active) stop();
      else if (changed) play();
    }

    function preferenceChanged() {
      replay.disabled = !valid || reduced.matches;
      if (reduced.matches) stop();
    }

    function destroy() {
      setActive(false);
      root.removeEventListener('click', onClick);
      root.removeAttribute('data-mfit-ready');
      instances.delete(root);
    }

    root.addEventListener('click', onClick);
    root.dataset.mfitReady = 'true';
    root.querySelector('[data-mfit-controls]').hidden = false;
    root.querySelector('[data-mfit-units]').hidden = !valid;
    root.querySelector('[data-mfit-tape]').hidden = !valid;
    root.querySelector('[data-mfit-unavailable]').hidden = valid;
    reading.hidden = !valid;
    replay.hidden = false;
    preferenceChanged();
    show('width', false);
    var instance = { setActive: setActive, stop: stop, preferenceChanged: preferenceChanged, destroy: destroy };
    instances.set(root, instance);
    return instance;
  }

  function roots(scope) {
    scope = scope || document;
    var result = scope.matches && scope.matches(selector) ? [scope] : [];
    if (scope.querySelectorAll) result = result.concat(Array.from(scope.querySelectorAll(selector)));
    return result;
  }

  function mount(scope) {
    instances.forEach(function (instance, root) { if (!root.isConnected) instance.destroy(); });
    roots(scope).forEach(setup);
  }

  function setActive(scope, value) {
    mount(scope);
    roots(scope).forEach(function (root) { setup(root).setActive(value); });
  }

  window.URAMobileFitDemo = { mount: mount, setActive: setActive };

  document.addEventListener('ura:mobile-panel-change', function (event) {
    var nav = event.target.closest && event.target.closest('[data-ura-mobile-nav]');
    if (!nav || (event.detail && event.detail.panel === 'fit')) return;
    setActive(nav, false);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) instances.forEach(function (instance) { instance.stop(); });
  });
  window.addEventListener('pagehide', function () { instances.forEach(function (instance) { instance.setActive(false); }); });
  reduced.addEventListener('change', function () { instances.forEach(function (instance) { instance.preferenceChanged(); }); });
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (instance, root) { if (event.target.contains(root)) instance.destroy(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
  else mount(document);
}());
